import BasePage from '../../components/base-page/base-page';
import ContactModal from '../../components/contact-modal/contact-modal';
import CategoryTabs from '../../components/category-tabs/category-tabs';
import type { UiElement } from '../../../shared/ui-element/ui-element';

import './case-study.scss';


class CaseStudyPage extends BasePage {
  contactModal = new ContactModal();

  categoryTabs = new CategoryTabs();

  onInit() {
    super.onInit();
    (this.contactModal as UiElement).init();
    this.categoryTabs.init();
  }
}

export default CaseStudyPage;

(CaseStudyPage as UiElement).initOnDomLoaded();
